<template>
  <div
    class="input-group mbr-textarea"
    :class="`input-group-${variant} ${getStatus(error, success)}`"
  >
    <textarea
      :id="id"
      class="form-control mbr-textarea__field"
      :rows="rows"
      :cols="cols"
      :name="name"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
      :placeholder="placeholder"
      :isRequired="isRequired"
      :disabled="disabled"
    ></textarea>
  </div>
</template>

<script>
import setMaterialInput from "@/assets/js/material-input.js";

export default {
  name: "MaterialTextarea",
  props: {
    variant: {
      type: String,
      default: "outline",
    },
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      default: "",
    },
    modelValue: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "Your text here...",
    },
    isRequired: Boolean,
    disabled: {
      type: Boolean,
      default: false,
    },
    rows: {
      type: Number,
      default: 4,
    },
    cols: {
      type: Number,
      default: 50,
    },
    success: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    setMaterialInput();
  },
  methods: {
    getStatus: (error, success) => {
      let isValidValue;

      if (success) {
        isValidValue = "is-valid";
      } else if (error) {
        isValidValue = "is-invalid";
      } else {
        isValidValue = null;
      }

      return isValidValue;
    },
  },
};
</script>

<style scoped>
/* Same field look as MaterialInput; !important outranks the Material Dashboard
   outline/underline rules on .input-group .form-control. */
.input-group.mbr-textarea .form-control.mbr-textarea__field {
  width: 100%;
  min-height: 120px;
  margin-left: 0 !important;
  padding: 14px var(--mbr-space-md) !important;
  background: var(--mbr-color-surface) !important;
  border: 1px solid var(--mbr-color-outline) !important;
  border-radius: var(--mbr-radius-lg) !important;
  font-family: var(--mbr-font-body);
  font-size: var(--mbr-body-md-size);
  font-weight: 500;
  line-height: var(--mbr-body-md-line);
  color: var(--mbr-color-ink-headline);
  box-shadow: none;
  resize: vertical;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.input-group.mbr-textarea .form-control.mbr-textarea__field::placeholder {
  color: var(--mbr-color-ink-muted);
  font-size: var(--mbr-body-md-size);
  font-weight: 500;
  text-align: start;
}

.input-group.mbr-textarea .form-control.mbr-textarea__field:focus {
  border-color: var(--mbr-color-primary) !important;
  box-shadow: 0 0 0 0.5px var(--mbr-color-primary);
}

.input-group.mbr-textarea .form-control.mbr-textarea__field:disabled {
  background: var(--mbr-color-tint) !important;
  cursor: not-allowed;
}

.input-group.mbr-textarea.is-invalid .form-control.mbr-textarea__field {
  border-color: var(--mbr-color-error) !important;
}
</style>
